function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import difference from 'lodash/difference';
import messages from 'modules/Patient/messages';
import { AppContext, ProfileContext } from 'context';
import { useAction } from 'hooks';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import { fetchSharingRequests, setNotes, setPhiSet } from 'modules/Patient/actions';
import { notesBatchesIndex as notesBatchesIndexSelector } from 'modules/Patient/selectors';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import styles from './VisitHistoryPage.pcss';
import VisitCard from './VisitCard';
const VisitHistoryPage = ()=>{
    useStyles(styles);
    const { redirect, getUrl } = useContext(AppContext);
    const profileContext = useContext(ProfileContext);
    const visits = useSelector(selectors.visits);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const passphrase = useSelector(profileContext.selectors.passphrase);
    const prvKeyPem = useSelector(profileContext.selectors.prvKeyPem);
    const patientProfile = useSelector(Account.selectors.patientProfile);
    const notesBatchesIndex = useSelector(notesBatchesIndexSelector);
    const connectToPatientStorage = useAction(Account.actions.connectToPatientStorage, patientProfile);
    const fetchNotes = useAction(CloudDrive.actions.fetchNotes);
    const fetchPhiSet = useAction(CloudDrive.actions.fetchPhiSet);
    const fetchVisitsMetadata = useAction(actions.fetchVisitsMetadata);
    const fetchSharingRequestsAction = useAction(fetchSharingRequests);
    useEffect(()=>{
        connectToPatientStorage(patientProfile);
        fetchSharingRequestsAction();
    }, []);
    useEffect(()=>{
        if (patientProfile.accessToken && !phiSet) {
            fetchPhiSet(patientProfile, setPhiSet);
        }
    }, [
        patientProfile
    ]);
    useEffect(()=>{
        if (phiSet && phiSet.visits && phiSet.visits.length) {
            fetchVisitsMetadata(phiSet.visits, prvKeyPem, passphrase);
        }
    }, [
        phiSet
    ]);
    const onFetchNotes = (visit)=>{
        const associatedNotesBatches = get(visit, 'associatedDataIndexKeys.notes', []);
        const diff = difference(associatedNotesBatches, notesBatchesIndex);
        if (!diff.length) {
            return;
        }
        const { phiSetReferenceKey, accessToken, storageProvider, phiSetDocumentId } = patientProfile;
        fetchNotes({
            phiSet,
            phiSetReferenceKey,
            phiSetDocumentId,
            notesBatchesIndex,
            accessToken,
            storageProvider,
            batches: associatedNotesBatches,
            successAction: setNotes
        });
    };
    const onShowNotes = (visit)=>{
        const { phisetVisitId } = visit;
        onFetchNotes(visit);
        redirect(getUrl('mobile-visit-notes', {
            phisetVisitId
        }));
    };
    if (phiSet && !(phiSet.visits && phiSet.visits.length)) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.infoContainer,
            children: /*#__PURE__*/ _jsx("p", {
                className: styles.infoHeader,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.noVisits))
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        children: [
            ...visits
        ].reverse().map((visit)=>{
            var _phiSet_visits;
            const phiVisit = phiSet === null || phiSet === void 0 ? void 0 : (_phiSet_visits = phiSet.visits) === null || _phiSet_visits === void 0 ? void 0 : _phiSet_visits.find((v)=>v.phisetVisitId === visit.phisetVisitId);
            return /*#__PURE__*/ _jsx(VisitCard, {
                visit: _object_spread_props(_object_spread({}, visit), {
                    newMessages: phiVisit === null || phiVisit === void 0 ? void 0 : phiVisit.newMessages
                }),
                onShowNotes: onShowNotes
            }, visit.phisetVisitId);
        })
    });
};
export default VisitHistoryPage;
